import { Box, Typography } from "@dealer-center/core-components";

export const AdvertisingSourcesPage = () => (
  <Box sx={{ p: 3 }}>
    <Typography variant="h6">Advertising Sources</Typography>
    <Typography sx={{ color: "text.secondary", mt: 1 }} variant="body-md">
      TODO: implement Advertising Sources
    </Typography>
  </Box>
);
